<template>
  <div>
    <!-- 使用 Vant 的 van-popup 组件 -->
    <van-popup
      v-model="visible"
      :position="position"
      :overlay="overlay"
      :close-on-click-overlay="overlayClick"
      :style="{ width: '85%' }"
      class="custom-popup"
      style="background: transparent"
    >
      <div class="c-content">
        <p class="coun-title f-t-18 f-w t-c">
          {{ $lang.common_txt272 }}
        </p>
        <div style="min-height: 180px">
          <div
            class="d-flex-s"
            style="flex-flow: wrap row; width: 85%; margin: 15px auto 0"
          >
            <div
              v-for="(item, index) in CountryList"
              :key="index"
              class="piker_mian_list d-flex m-b-5"
              :class="{ 'active-coun': selectIndex === index }"
              style="width: 48.5%; padding: 0 10px"
              @click="selectFun(index, item)"
            >
              <img :src="item.iconUrl" width="41" />
              <span class="m-l-5">{{ item.countryName }}</span>
            </div>
          </div>
        </div>
        <div class="d-flex" style="width: 85%; margin: 0 auto">
          <img src="../assets/img/otgame/xzgj_3.png" width="14" />
          <span class="m-l-5" style="font-size: var(--vk-fs-sm)">{{ $lang.common_txt273 }}</span>
        </div>
        <div style="text-align: center; margin-top: 20px; padding-bottom: 16px">
          <van-button
            size="large"
            class="custom-button"
            @click="confirm"
            :disabled="selectIndex === null"
            style="width: 60%; height: 35px; border-radius: 20px"
          >
            {{ $lang.Confirmar }}
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { GetPlatformList } from '@/api/common'
import { failMessage, isNeedLogin, isOkResponse, normalizePlatformList, safeString } from '@/components/loginFlow'
import { logoutIfReloginRequiredWithToken } from '@/utils/platformAuth'
import { safeGetStorageItem, safeLocalStorage, safeSetStorageItem } from '@/utils/safeStorage'

function guardedLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) {
    return null
  }
  return null
}

function reloadLocationSafely() {
  try {
    const location = typeof window !== 'undefined' && window ? window.location : null
    if (location && typeof location.reload === 'function') {
      location.reload()
      return true
    }
  } catch (e) {
    return false
  }
  return false
}

export default {
  name: 'CommonLang',
  props: {
    overlayClick: {
      type: Boolean,
      default: false
    },
    // 控制弹窗显示的布尔值
    value: {
      type: Boolean,
      default: false
    },
    // 弹窗位置（top、bottom、left、right、center）
    position: {
      type: String,
      default: 'center'
    },
    // 是否显示遮罩层
    overlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      info: {},
      selectIndex: null,
      CountryList: [], // 初始化为空数组，等待接口返回数据
      visible: this.value, // 内部状态
      isLoading: false // 新增：请求锁，防止重复请求
    }
  },
  watch: {
    // 监听外部传入的 value 值变化
    value(newVal) {
      this.visible = newVal
      if (newVal) {
        this.ensurePlatformList()
      }
      // 弹窗关闭时重置选中状态，确保下次打开按钮是禁用的
      if (!newVal) {
        this.selectIndex = null
      }
    },
    // 监听内部 visible 值变化，同步到外部 + 触发接口请求
    visible(newVal) {
      this.$emit('input', newVal)
      if (newVal) {
        this.ensurePlatformList()
      }
    }
  },
  mounted() {
    this.ensurePlatformList()
  },
  created() {},
  methods: {
    ensurePlatformList() {
      if (this.visible && this.CountryList.length === 0 && !this.isLoading) {
        this.GetPlatformList()
      }
    },
    async GetPlatformList() {
      // 新增：请求锁，防止同一时间多次触发请求
      if (this.isLoading) return
      this.isLoading = true

      try {
        const data = await GetPlatformList()
        const platformList = normalizePlatformList(data)
        if (this.isReadablePlatformList(data, platformList)) {
          this.CountryList = platformList
          // 单一国家实例:平台列表只有 1 个时自动选中并确认,跳过多余的单选项弹窗。
          // config 驱动 —— 任何单国实例(当前科特迪瓦)都成立,不写死 CIV;多国时仍正常手选。
          // 复用现有手选的同一条 confirm 路径(/Country → 存上下文 → 跳 /{country}/home),零新风险。
          if (this.CountryList.length === 1 && this.isValidPlatformSelection(this.CountryList[0])) {
            this.selectFun(0, this.CountryList[0])
            this.confirm()
            return
          }
        } else {
          this.showFailToast({
            message: this.platformListFailMessage(data),
            icon: 'cross'
          })
        }
      } catch (error) {
        this.showFailToast({
          message: this.platformListFailMessage(error),
          icon: 'cross'
        })
      } finally {
        // 无论请求成功/失败，都释放请求锁
        this.isLoading = false
      }
    },
    isReadablePlatformList(data, platformList) {
      if (isNeedLogin(data) || !Array.isArray(platformList) || platformList.length === 0) return false
      if (isOkResponse(data)) return true
      const layers = [data, data && data.content, data && data.data, data && data.payload]
        .filter((item) => item && typeof item === 'object')
      return !layers.some((item) => (
        item.status === 'fail' ||
        item.success === false ||
        item.readFailure === true ||
        item.read_failure === true ||
        item.readUnavailable === true ||
        item.read_unavailable === true ||
        item.fallback === true ||
        item.dataUnavailable === true ||
        item.data_unavailable === true
      ))
    },
    confirm() {
      // 双重校验，确保只有选中后才执行逻辑
      if (this.selectIndex === null || this.CountryList.length === 0 || !this.isValidPlatformSelection(this.info)) {
        this.showFailToast({
          message: this.$lang.region_select_required || 'Please select a valid region and try again.',
          icon: 'cross'
        })
        return
      }
      const storage = guardedLocalStorage()
      const prevPlatform = safeGetStorageItem(storage, 'platform')
      logoutIfReloginRequiredWithToken(prevPlatform, this.info.platform)
      safeSetStorageItem(storage, 'currency', safeString(this.info.currency))
      safeSetStorageItem(storage, 'areaCode', safeString(this.info.areaCode))
      safeSetStorageItem(storage, 'currencyUnit', safeString(this.info.currencyUnit))
      safeSetStorageItem(storage, 'platform', safeString(this.info.platform))
      safeSetStorageItem(storage, 'defaultLanguage', safeString(this.info.defaultLanguage))
      safeSetStorageItem(storage, 'iconUrl', safeString(this.info.iconUrl))
      safeSetStorageItem(storage, 'countryName', safeString(this.info.countryName))
      safeSetStorageItem(storage, 'country', safeString(this.info.country))
      if (this.$route.path.includes('/Country')) {
        this.$router.replace('/' + this.info.country + '/home')
      }
      setTimeout(() => {
        reloadLocationSafely()
      }, 200)
    },
    selectFun(i, v) {
      this.info = v
      this.selectIndex = i
    },
    isValidPlatformSelection(info) {
      return !!(
        info &&
        safeString(info.country) &&
        safeString(info.platform) &&
        safeString(info.currency)
      )
    },
    platformListFailMessage(res) {
      return failMessage(res, this.$lang.country_list_unavailable || 'Country/region list is unavailable. Please try again later.')
    },
    showFailToast(payload) {
      if (typeof this.$toast === 'function') {
        this.$toast(payload)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.c-content {
  background: var(--vk-surface);
  border: 0.5px solid var(--vk-border);
  border-radius: var(--vk-r-lg);
  overflow: hidden;
  min-height: 320px;
  color: var(--vk-t1);
}
/* 火焰橙标题栏(替代原 PNG 绿色头部) */
.coun-title {
  margin: 0;
  padding: 13px 0;
  color: #fff;
  background: var(--vk-grad);
}
.piker_mian_list {
  background: var(--vk-surface-2);
  border: 1px solid var(--vk-border);
  border-radius: var(--vk-r-md);
  height: 48px;
  color: var(--vk-t1);
}
/* 选中态=火焰橙描边(铁律①) */
.active-coun {
  background: var(--vk-surface-2) !important;
  border-color: var(--vk-brand) !important;
  box-shadow: 0 0 0 1px var(--vk-brand) inset;
  height: 48px !important;
}

/* Confirm 主按钮=火焰橙;禁用置灰 */
.custom-button {
  background: var(--vk-grad);
  color: #fff;
  border: none;
  &.van-button--disabled {
    background: var(--vk-surface-2);
    color: var(--vk-t3);
    cursor: not-allowed;
  }
}
</style>
